import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 60,
    backgroundColor: theme.palette.background.default,
    justifyContent: 'center',
  },
  label: {
    fontFamily: 'Inter600',
    color: '#18191F',
    fontSize: 18,
  },
  img: {
    width: '100%',
  },
  warningImage: {
    marginRight: 10,
    width: 30,
  },
  message: {
    textAlign: 'center',
    fontFamily: 'Inter500',
    fontSize: 16,
  },
}));

const Stepper = ({ order }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = order?.captureImages?.length ?? 0;

  const handleNext = () =>
    setActiveStep((prevActiveStep) => prevActiveStep + 1);

  const handleBack = () =>
    setActiveStep((prevActiveStep) => prevActiveStep - 1);

  const activeCapture = order?.captureImages?.[activeStep];
  const imageSplit = activeCapture?.liveImage?.split('/upload/');
  const activeImage = imageSplit
    ? `${imageSplit[0]}/upload/${imageSplit[1]}`
    : 'https://res.cloudinary.com/big-oven-tees-inc/image/upload/v1631199707/Shirtly/Web_Pages/LandingPage/Header/shirtly-premium-logo_sscytx_royuzk.png';

  return (
    <div>
      <div
        style={{
          backgroundImage: `url(${activeImage})`,
          height: 350,
          maxHeight: 350,
          overflow: 'hidden',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50% 50%',
        }}
      />
      <p className={classes.message}>
        You will see more product images as soon as your order line products
        been printed.
      </p>
      <MobileStepper
        style={{ marginTop: 30, marginBottom: 30 }}
        steps={maxSteps}
        position='static'
        variant='text'
        activeStep={activeStep}
        nextButton={
          <Button
            size='small'
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}>
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size='small' onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </div>
  );
};

export default Stepper;
